import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { IfaListContainerComponent } from '@root/components/ifa-list/ifa-list-container/ifa-list-container.component';

@Component({
  selector: 'app-ifa-block-dialog',
  templateUrl: './ifa-block-dialog.component.html',
  styleUrls: ['./ifa-block-dialog.component.scss'],
})
export class IfaBlockDialogComponent implements OnInit {

  device:any;

  ifa :any;

  isBlock:boolean;
  
  constructor(
    public dialogRef: MatDialogRef<IfaListContainerComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.ifa = data.ifa;
    this.isBlock = data.isBlock;

    if( data.device){
      this.device = data.device;
    }
  }

  ngOnInit() {}

  public onConfirmation() {
    const response = {'ifa': this.ifa , 'device': this.device ,  'isBlock': this.isBlock};
    this.dialogRef.close(response);
  }

}
